import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Header } from '../../components/layout/Header';
import { Footer } from '../../components/layout/Footer';
import { Button } from '../../components/ui/Button';
import { Card, CardContent } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Input } from '../../components/ui/Input';
import { MapPlaceholder } from '../../components/ui/MapPlaceholder';
import { Calendar, MapPin, Clock, Users, Share2, AlertCircle, CheckCircle2, ArrowLeft } from 'lucide-react';
export function EventDetailPage() {
  const {
    id
  } = useParams();
  const [isRegistered, setIsRegistered] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleRegister = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setIsRegistered(true);
    }, 1500);
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col font-sans" data-id="element-4071">
      <Header data-id="element-4072" />

      <main className="flex-1" data-id="element-4073">
        {/* Breadcrumb & Back */}
        <div className="bg-white border-b border-gray-200 py-4" data-id="element-4074">
          <div className="container mx-auto px-4 md:px-6" data-id="element-4075">
            <Link to="/event" className="inline-flex items-center text-sm text-gray-500 hover:text-primary-600" data-id="element-4076">
              <ArrowLeft className="h-4 w-4 mr-1" data-id="element-4077" /> Kembali ke Daftar Event
            </Link>
          </div>
        </div>

        {/* Hero Content */}
        <div className="container mx-auto px-4 md:px-6 py-8" data-id="element-4078">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-4079">
            {/* Left Column: Main Content */}
            <div className="lg:col-span-2 space-y-8" data-id="element-4080">
              {/* Image Banner */}
              <div className="w-full h-64 md:h-96 bg-gray-200 rounded-2xl overflow-hidden relative" data-id="element-4081">
                <div className="absolute inset-0 flex items-center justify-center bg-gray-300" data-id="element-4082">
                  <Calendar className="h-20 w-20 text-gray-400" data-id="element-4083" />
                </div>
                <div className="absolute top-4 left-4" data-id="element-4084">
                  <Badge className="bg-primary-600 text-white hover:bg-primary-700 text-sm py-1 px-3" data-id="element-4085">
                    Clean Up
                  </Badge>
                </div>
              </div>

              {/* Title & Meta */}
              <div data-id="element-4086">
                <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-4087">
                  Aksi Bersih Pantai Ancol: Road to HPSN 2025
                </h1>
                <div className="flex flex-wrap gap-4 text-gray-600 mb-6" data-id="element-4088">
                  <div className="flex items-center gap-2" data-id="element-4089">
                    <Calendar className="h-5 w-5 text-primary-600" data-id="element-4090" />
                    <span data-id="element-4091">Minggu, 25 Februari 2025</span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-4092">
                    <Clock className="h-5 w-5 text-primary-600" data-id="element-4093" />
                    <span data-id="element-4094">06:00 - 10:00 WIB</span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-4095">
                    <MapPin className="h-5 w-5 text-primary-600" data-id="element-4096" />
                    <span data-id="element-4097">Pantai Lagoon, Ancol</span>
                  </div>
                </div>
              </div>

              {/* Description */}
              <div className="prose max-w-none text-gray-600" data-id="element-4098">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-4099">
                  Deskripsi Kegiatan
                </h3>
                <p className="mb-4" data-id="element-4100">
                  Bergabunglah dalam aksi nyata membersihkan pesisir Jakarta!
                  Dalam rangka menyambut Hari Peduli Sampah Nasional 2024, kami
                  mengajak seluruh elemen masyarakat untuk turun tangan
                  membersihkan sampah di area Pantai Ancol.
                </p>
                <p className="mb-4" data-id="element-4101">
                  Kegiatan ini tidak hanya sekadar memungut sampah, tetapi juga
                  melakukan pemilahan dan pendataan jenis sampah (brand audit)
                  untuk data riset nasional.
                </p>

                <h3 className="text-xl font-bold text-gray-900 mb-3 mt-6" data-id="element-4102">
                  Rangkaian Acara
                </h3>
                <ul className="list-disc pl-5 space-y-2" data-id="element-4103">
                  <li data-id="element-4104">06:00 - Registrasi Ulang & Briefing</li>
                  <li data-id="element-4105">06:30 - Senam Pagi Bersama</li>
                  <li data-id="element-4106">07:00 - Aksi Bersih Pantai & Pemilahan</li>
                  <li data-id="element-4107">09:00 - Penimbangan & Pencatatan</li>
                  <li data-id="element-4108">09:30 - Hiburan & Doorprize</li>
                </ul>

                <h3 className="text-xl font-bold text-gray-900 mb-3 mt-6" data-id="element-4109">
                  Fasilitas Relawan
                </h3>
                <ul className="list-disc pl-5 space-y-2" data-id="element-4110">
                  <li data-id="element-4111">Sarung tangan & karung sampah</li>
                  <li data-id="element-4112">Snack & air minum (bawa tumbler sendiri)</li>
                  <li data-id="element-4113">E-Sertifikat Nasional</li>
                  <li data-id="element-4114">
                    Tiket masuk Ancol gratis (bagi pendaftar terkonfirmasi)
                  </li>
                </ul>
              </div>

              {/* Map */}
              <div data-id="element-4115">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-4116">
                  Lokasi Titik Kumpul
                </h3>
                <div className="h-64 rounded-xl overflow-hidden border border-gray-200 shadow-sm" data-id="element-4117">
                  <MapPlaceholder data-id="element-4118" />
                </div>
                <p className="mt-2 text-sm text-gray-500" data-id="element-4119">
                  Titik kumpul: Parkir Timur Pantai Lagoon, Ancol, Jakarta
                  Utara.
                </p>
              </div>
            </div>

            {/* Right Column: Sidebar */}
            <div className="lg:col-span-1 space-y-6" data-id="element-4120">
              {/* Registration Card */}
              <Card className="sticky top-24 border-primary-100 shadow-lg overflow-hidden" data-id="element-4121">
                <div className="bg-primary-50 p-4 border-b border-primary-100" data-id="element-4122">
                  <div className="flex justify-between items-center mb-1" data-id="element-4123">
                    <span className="text-sm font-medium text-primary-700" data-id="element-4124">
                      Status Pendaftaran
                    </span>
                    <Badge className="bg-green-100 text-green-700 border-green-200" data-id="element-4125">
                      Buka
                    </Badge>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2 mt-2" data-id="element-4126">
                    <div className="bg-primary-600 h-2 rounded-full" style={{
                    width: '75%'
                  }} data-id="element-4127"></div>
                  </div>
                  <p className="text-xs text-gray-500 mt-1 text-right" data-id="element-4128">
                    150 / 200 Kuota Terisi
                  </p>
                </div>

                <CardContent className="p-6" data-id="element-4129">
                  {!isRegistered ? <form onSubmit={handleRegister} className="space-y-4" data-id="element-4130">
                      <h3 className="font-bold text-gray-900 text-lg mb-2" data-id="element-4131">
                        Daftar Sebagai Relawan
                      </h3>

                      <div className="space-y-2" data-id="element-4132">
                        <label className="text-sm font-medium" data-id="element-4133">
                          Nama Lengkap
                        </label>
                        <Input required placeholder="Sesuai KTP" data-id="element-4134" />
                      </div>

                      <div className="space-y-2" data-id="element-4135">
                        <label className="text-sm font-medium" data-id="element-4136">Email</label>
                        <Input required type="email" placeholder="nama@email.com" data-id="element-4137" />
                      </div>

                      <div className="space-y-2" data-id="element-4138">
                        <label className="text-sm font-medium" data-id="element-4139">
                          Nomor WhatsApp
                        </label>
                        <Input required type="tel" placeholder="0812..." data-id="element-4140" />
                      </div>

                      <div className="space-y-2" data-id="element-4141">
                        <label className="text-sm font-medium" data-id="element-4142">
                          Instansi / Komunitas
                        </label>
                        <Input placeholder="Opsional" data-id="element-4143" />
                      </div>

                      <div className="pt-2" data-id="element-4144">
                        <Button type="submit" className="w-full bg-primary-600 hover:bg-primary-700 h-12 text-lg font-semibold" disabled={isSubmitting} data-id="element-4145">
                          {isSubmitting ? 'Memproses...' : 'Daftar Sekarang'}
                        </Button>
                        <p className="text-xs text-gray-500 text-center mt-3" data-id="element-4146">
                          Dengan mendaftar, Anda menyetujui syarat & ketentuan
                          kegiatan.
                        </p>
                      </div>
                    </form> : <div className="text-center py-6 animate-in fade-in zoom-in" data-id="element-4147">
                      <div className="h-16 w-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-4148">
                        <CheckCircle2 className="h-8 w-8 text-green-600" data-id="element-4149" />
                      </div>
                      <h3 className="font-bold text-xl text-gray-900 mb-2" data-id="element-4150">
                        Pendaftaran Berhasil!
                      </h3>
                      <p className="text-gray-600 text-sm mb-6" data-id="element-4151">
                        Tiket elektronik telah dikirim ke email Anda. Silakan
                        cek inbox/spam folder.
                      </p>
                      <Button variant="outline" className="w-full" onClick={() => setIsRegistered(false)} data-id="element-4152">
                        Daftar Peserta Lain
                      </Button>
                    </div>}
                </CardContent>
              </Card>

              {/* Organizer Info */}
              <Card data-id="element-4153">
                <CardContent className="p-6" data-id="element-4154">
                  <h4 className="font-semibold text-gray-900 mb-4" data-id="element-4155">
                    Penyelenggara
                  </h4>
                  <div className="flex items-center gap-3 mb-4" data-id="element-4156">
                    <div className="h-10 w-10 bg-gray-200 rounded-full flex items-center justify-center" data-id="element-4157">
                      <Users className="h-5 w-5 text-gray-500" data-id="element-4158" />
                    </div>
                    <div data-id="element-4159">
                      <p className="font-medium text-gray-900" data-id="element-4160">
                        Komunitas Peduli Jakarta
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-4161">
                        Verified Organizer
                      </p>
                    </div>
                  </div>
                  <Button variant="outline" size="sm" className="w-full" data-id="element-4162">
                    Hubungi Penyelenggara
                  </Button>
                </CardContent>
              </Card>

              {/* Share */}
              <div className="text-center" data-id="element-4163">
                <p className="text-sm text-gray-500 mb-3" data-id="element-4164">Bagikan event ini</p>
                <div className="flex justify-center gap-2" data-id="element-4165">
                  <Button variant="outline" size="icon" className="rounded-full" data-id="element-4166">
                    <Share2 className="h-4 w-4" data-id="element-4167" />
                  </Button>
                  {/* Social icons placeholders */}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Related Events */}
        <section className="bg-white py-12 border-t border-gray-100 mt-12" data-id="element-4168">
          <div className="container mx-auto px-4 md:px-6" data-id="element-4169">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-4170">
              Event Serupa Lainnya
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-4171">
              {[1, 2, 3].map(i => <Card key={i} className="hover:shadow-md transition-shadow" data-id="element-4172">
                  <CardContent className="p-4" data-id="element-4173">
                    <div className="flex gap-4" data-id="element-4174">
                      <div className="h-20 w-20 bg-gray-200 rounded-lg flex-shrink-0" data-id="element-4175"></div>
                      <div data-id="element-4176">
                        <h4 className="font-bold text-gray-900 line-clamp-2 mb-1" data-id="element-4177">
                          Workshop Pengelolaan Sampah Organik #{i}
                        </h4>
                        <p className="text-xs text-gray-500 mb-2" data-id="element-4178">
                          28 Feb 2025 • Jakarta Selatan
                        </p>
                        <Link to={`/event/${i}`} className="text-sm font-medium text-primary-600 hover:underline" data-id="element-4179">
                          Lihat Detail
                        </Link>
                      </div>
                    </div>
                  </CardContent>
                </Card>)}
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-4180" />
    </div>;
}